<template lang="html">
  <div class="service">
    <bannerTop :banners="$t('crm.banners')" :iscustom="true" :bgPosition="bgPosition"></bannerTop>
    <div class="step one">
      <label class="labelTitle">{{titleToUpperCase($t('crm.step1.title'))}}</label>
      <p class="description" v-if="$t('crm.step1.description')" v-html="$t('crm.step1.description')"></p>
      <ul class="cases">
        <li v-for="(item,key) in $t('crm.step1.cases')" :key="key">
          <img :src="item.imgUrl" alt="">
          <span class="title" v-html="item.title"></span>
        </li>
      </ul>
    </div>
    <div class="step two">
      <label class="labelTitle">{{titleToUpperCase($t('crm.step2.title'))}}</label>
      <p class="description" v-if="$t('crm.step2.description')" v-html="$t('crm.step2.description')"></p>
      <ul class="cases">
        <li v-for="(item,key) in $t('crm.step2.cases')" :key="key">
          <img :src="item.imgUrl" alt="">
          <span class="title" v-html="item.title"></span>
          <span class="description" v-html="item.description"></span>
        </li>
      </ul>
    </div>
    <div class="step three">
      <div class="left">
        <!-- <img src="../../assets/images/services/crm/placeholder1.jpg" alt=""> -->
      </div>
      <div class="right">
        <label class="labelTitle">{{titleToUpperCase($t('crm.step3.title'))}}</label>
        <p class="description" v-if="$t('crm.step3.description')" v-html="$t('crm.step3.description')"></p>
      </div>
    </div>
    <div class="step four">
     <div class="left">
       <label class="labelTitle">{{titleToUpperCase($t('crm.step4.title'))}}</label>
       <p class="secondTitle" v-html="$t('crm.step4.secondTitle')"></p>
       <p class="description" v-if="$t('crm.step4.description')" v-html="$t('crm.step4.description')"></p>
     </div>
     <div class="right">
       <ul class="cases">
         <li v-for="(item,key) in $t('crm.step4.cases')" :key="key">
           <div class="info">
             <img :src="item.imgUrl" alt="">
             <span class="title" v-html="titleToUpperCase(item.title)"></span>
           </div>
           <span class="description" v-html="item.description"></span>
         </li>
       </ul>
     </div>
    </div>
    <div class="step five">
      <div class="left">
        <label class="labelTitle">{{titleToUpperCase($t('crm.step5.title'))}}</label>
        <p class="description" v-if="$t('crm.step5.description')" v-html="$t('crm.step5.description')"></p>
        <!-- <img src="../../assets/images/services/crm/placeholder1.jpg" alt=""> -->
      </div>
      <div class="right">
      </div>
    </div>
  </div>
</template>

<script>
import bannerTop from '@/components/bannerTop'
export default {
  name: 'applicationOutsourcing',
  data(){
    return{
      bgPosition: 'center right'
    }
  },
  components:{
    bannerTop
  },
  created(){
  }
}
</script>

<style lang="less" src="../../assets/css/service.less"></style>
